import _ from 'lodash';
import { createSelector } from 'reselect';
import {TABS} from 'MyAccount/ViewDesigns/consts';
import {getFolderIdByName} from 'MyAccount/ViewTemplates/helpers/folderName';
import {SEE_ALL_THEMES, BASIC} from 'MyAccount/ViewDesigns/NewViewDesigns';
const getUserTemplates = (state) => (state.templates.userTemplates);
const getTemplateList = (state) => (state.templates.templateList);
const getPrefetchedTemplates = (state) => (state.templates.prefetchedTemplates);
const getSelectedTag = (state) => (state.routing.location.query.selectedTag);
const getSelectedTab = (state) => (state.routing.location.query.selectedTab || TABS.THEMES);

export const getTemplatesById = createSelector(
  [getUserTemplates],
  (userTemplates) => {
    return _.keyBy(_.flatten(_.map(userTemplates, templates => {
      return templates;
    })), 'id');
  }
);

export const getTemplatesBySelectedTag = createSelector(
  [getTemplateList, getSelectedTag, getSelectedTab, getUserTemplates],
  (templates, selectedTag, selectedTab, userTemplates) => {
    if (selectedTab === TABS.THEMES) {
      if (selectedTag === SEE_ALL_THEMES || _.isEmpty(selectedTag)) return _.omitBy(templates, (template) => {return (_.findIndex(template.categories, (category) => {return category === BASIC;}) !== -1);});
      return _.omitBy(templates, (template) => _.indexOf(template.categories, selectedTag) === -1);
    }
    if (selectedTab === TABS.SAVED_TEMPLATES) {
      const folderId = getFolderIdByName(selectedTag);
      if (_.has(userTemplates, folderId)) {
        return _.keyBy(userTemplates[folderId], 'id');
      }
      return null;
    }
  }
);

